import { useQuery } from '@tanstack/react-query';
import { subscriptionService, type Subscription } from '@/services/subscription/subscription.service';
import { useCompanyStore } from '@/store/use-company-store';
import { useAuthStore } from '@/store/use-auth-store';

export const useSubscription = () => {
  const { currentCompanyId } = useCompanyStore();
  const { isAuthenticated } = useAuthStore();
  
  return useQuery<Subscription | null>({
    queryKey: ['subscription', 'me', currentCompanyId],
    queryFn: () => subscriptionService.getMySubscription(),
    enabled: isAuthenticated && !!currentCompanyId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

